export default "__VITE_ASSET__DoO1x59c__"